import { computed, ref, ComputedRef } from 'vue'
import { useApi } from '@/composables/useApi'

export type DeliveryReactionStatus = {
    [key: string]: string | number
    id: number
    name: string
    symbol: string
}

const isLoading = ref<boolean>(false)
const deliveryReactionStatuses = ref<DeliveryReactionStatus[]>([])
const isEmpty = computed(() => deliveryReactionStatuses.value.length === 0)

export const useDeliveryReactionStatuses = (): {
    fetchDeliveryReactionStatuses: () => Promise<void>
    deliveryReactionStatuses: ComputedRef<DeliveryReactionStatus[]>
    isLoading: ComputedRef<boolean>
    isEmpty: ComputedRef<boolean>
} => {
    const { useGet } = useApi()

    async function fetchDeliveryReactionStatuses(): Promise<void> {
        if (!isEmpty.value) return

        isLoading.value = true
        try {
            const { status, data } = await useGet('/delivery-reaction-statuses')
            if (status === 200 && data.data) {
                deliveryReactionStatuses.value = data.data.items
            }
        } finally {
            isLoading.value = false
        }
    }

    return {
        fetchDeliveryReactionStatuses,
        deliveryReactionStatuses: computed(() => deliveryReactionStatuses.value),
        isLoading: computed(() => isLoading.value),
        isEmpty,
    }
}
